import theme from '@myphx-engineering/phx-theme';

export const brandConstants: Record<
    string,
    {
        theme: typeof theme;
        logoPath: string;
    }
> = {
    LillyDirect: {
        theme: theme,
        logoPath: '/static/img/prescryptive-powered-logo.svg',
    },
    Prescryptive: {
        theme: theme,
        logoPath:
            '/static/libraries/myphx-lib/application-header/myprescryptive-logo.png',
    },
};
